import type { NativeRouteMeta } from '@retailer-platform/dashboard/routing-native'
import type { routes } from './routes'

export const nativeRouteMeta = {
  name: 'shifts',
  autoEnable: true,
} as const satisfies NativeRouteMeta<keyof typeof routes>
